import React, { useContext, useRef, useState } from "react";
import { Plus } from "lucide-react";
import FindGeneric from "~/components/Finds/FindGeneric";
import InputLine from "~/components/RegisterForm/InputLine";

export function useApproverSlots(initialUsers = []) {
  const counter = useRef(0);
  const make = (user = null) => ({ uid: ++counter.current, user });
  const [slots, setSlots] = useState(() => initialUsers.map((user) => make(user)));
  return {
    slots,
    fill: (users) => setSlots(users.map((user) => make(user))),
    add: () => setSlots((current) => [...current, make()]),
    remove: (uid) => setSlots((current) => current.filter((slot) => slot.uid !== uid)),
    pick: (uid, user) => setSlots((current) => current.map((slot) => (slot.uid === uid ? { ...slot, user } : slot))),
    ids: () => [...new Set(slots.map((slot) => slot.user?.id).filter(Boolean))],
  };
}

export default function ApproverSlots({ state, InputContext, hint }) {
  const { setSuccessfullyUpdated } = useContext(InputContext);
  return (
    <>
      {state.slots.map((slot, index) => (
        <FindGeneric
          key={slot.uid}
          route="users"
          title={`Approver ${index + 1}`}
          scope={`approver${slot.uid}`}
          InputContext={InputContext}
          defaultValue={slot.user}
          setReturnFindGeneric={(row) => state.pick(slot.uid, row)}
          handleRemove={() => {
            state.remove(slot.uid);
            setSuccessfullyUpdated(false);
          }}
          fields={[
            { title: "Name", name: "name" },
            { title: "E-mail", name: "email" },
          ]}
        />
      ))}
      <InputLine>
        <div className="flex flex-col gap-2 items-start">
          <button
            type="button"
            onClick={() => {
              state.add();
              setSuccessfullyUpdated(false);
            }}
            className="flex items-center gap-2 text-xs font-bold bg-secondary border hover:border-primary hover:text-primary rounded-md px-3 h-8"
          >
            <Plus size={14} /> Add approver
          </button>
          {hint && <span className="text-xs text-gray-500">{hint}</span>}
        </div>
      </InputLine>
    </>
  );
}
